export default __webpack_public_path__ + "locales/sr-Cyrl-RS/Settings.json?hash=847dbd2faf959f4105574b69f263daf5";